import { useCallback, useMemo, useState } from 'react';
import { DuplicateDialogProps, DuplicateSource } from './duplicate.domain';

type Pending = { workoutId: number; programId: number };

type DuplicateWorkoutVM = {
  duplicate: (source: DuplicateSource) => void;
  dialog: DuplicateDialogProps | null;
};

// A workout outside any collection has nothing to ask about, so it clones
// straight away. One inside a collection asks where the copy should land.
export const useDuplicateWorkout = (
  influencerId: number,
  clone: (workoutId: number, targetProgramId: number | undefined) => void,
): DuplicateWorkoutVM => {
  const [pending, setPending] = useState<Pending | null>(null);

  const duplicate = useCallback(
    (source: DuplicateSource) => {
      if (source.programId === null) {
        clone(source.workoutId, undefined);
        return;
      }
      setPending({ workoutId: source.workoutId, programId: source.programId });
    },
    [clone],
  );

  const dialog = useMemo<DuplicateDialogProps | null>(
    () =>
      pending
        ? {
            influencerId,
            sourceProgramId: pending.programId,
            onConfirm: (targetProgramId) => {
              setPending(null);
              clone(pending.workoutId, targetProgramId);
            },
            onClose: () => setPending(null),
          }
        : null,
    [pending, influencerId, clone],
  );

  return { duplicate, dialog };
};
